import React from 'react';

type OfferingSetupValidationContextValue = {
  shouldValidate?: boolean;
  setShouldValidate?: (shouldValidate: boolean) => void;
};

const defaultValidationContextValue: OfferingSetupValidationContextValue = {
  shouldValidate: false,
  setShouldValidate: () => undefined,
};

const OfferingSetupValidationContext = React.createContext<OfferingSetupValidationContextValue>(
  defaultValidationContextValue
);

/**
 * Hook exposes shouldValidate boolean context
 * as well as update function to set shouldValidate
 */
export const useShouldValidate = () => React.useContext(OfferingSetupValidationContext);

/**
 * Wraps Offering Setup with a context provider which triggers validation if necessary
 */
export const OfferingSetupValidationProvider: React.FC<React.PropsWithChildren> = props => {
  const [shouldValidate, setShouldValidate] = React.useState<boolean>(false);

  return (
    <OfferingSetupValidationContext.Provider value={{ shouldValidate, setShouldValidate }}>
      {props.children}
    </OfferingSetupValidationContext.Provider>
  );
};

export default OfferingSetupValidationProvider;
